import { render } from "./NotFound.vue?vue&type=template&id=cbe8836a"
const script = {}

import exportComponent from "D:\\Диск D старый\\Lessons\\Vuew\\Azbyka\\dobroazbyka\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__